export function preventedDefault(handler) {
  return e => {
    e.preventDefault();
    handler();
  };
}
